import type { DateLocale } from "@repo/utils/date";
import { useTranslation } from "react-i18next";

/** Date locale of an i18next language: English for `en*`, French otherwise. */
export function toDateLocale(language: string | undefined): DateLocale {
  return language?.toLowerCase().startsWith("en") ? "en" : "fr";
}

/** Date locale following the current i18next language. */
export function useDateLocale(): DateLocale {
  const { i18n } = useTranslation();
  return toDateLocale(i18n.language);
}
